import store from '../store'
import axios from "axios";

export default async (to, from, next) => {
    if (store.getters['auth/check']) {

        if (from.name !=null && to.name != 'waiting' && store.getters['auth/user'].subscription_status == "152")
            axios.get(`${config.appUrl}/api/self?check=1`).then(({ data }) => {
                if (!data.check)
                    next({name: 'waiting',query: from.query})
            });
    }
    next();

}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/auth.js